import { useMemo } from "react";

import { useActiveFeatureFlags } from "posthog-js/react";

import { SourceType } from "@gx/ts-contracts/services/database/models/public_pb";

import { SOURCE_TYPE_TO_FEATURE_FLAG_MAP } from "@/pages/sources/constants";

export const useSourceTypesEnabled = (): Record<SourceType, boolean> => {
  const activeFlags = useActiveFeatureFlags();

  return useMemo(() => {
    const result: Record<number, boolean> = {};

    for (const sourceType of Object.values(SourceType).filter(
      (v): v is SourceType => typeof v === "number",
    )) {
      const featureFlag = SOURCE_TYPE_TO_FEATURE_FLAG_MAP[sourceType];
      if (featureFlag === undefined) {
        result[sourceType] = false;
      } else {
        result[sourceType] = activeFlags?.includes(featureFlag) ?? false;
      }
    }

    return result as Record<SourceType, boolean>;
  }, [activeFlags]);
};
